module.exports = __webpack_public_path__ + "static/media/petapp_bg.595e9b41.png";